import { FC, useMemo } from "react";
import { CampaignType } from "@vviinn/user-managment-client-ts";

import { RenderSwitchableSettings } from "./index";
import { CampaignPreset } from "./CampaignPreset";
import { CampaignTypeRadio } from "./CampaignTypeRadio";
import {
  controlledInputTitles,
  generalInformationSwitchableSettings,
  preferredImageSettings,
  selectSettingsTitles,
} from "../../constants";
import { generalInformationNumericSettings } from "../constants";
import { NamedSelect } from "../../../ui/layout/molecules/NamedSelect";
import { StateAction } from "../../../helpers/functions/types";
import { CampaignCommonProps, Preset } from "../types";
import { INPUT_FIELD_STYLES } from "../../../ui/layout/detailedPages/styles";
import { NamedNumberic } from "../../../ui/layout/molecules/NamedNumberic";
import { FormRow, InfoRow, SubSectionWithStyles } from "../../../ui/layout";
import { parseNumberOrZero } from "../../../helpers";

export const GeneralSettings: FC<
  CampaignCommonProps & {
    campaignType?: CampaignType | "BOOSTING";
    setCampaignType: StateAction<CampaignType | "BOOSTING" | undefined>;
    showAdvancedSettings?: boolean;
    setShowAdvancedSettings: StateAction<boolean>;
    presetData: Preset;
  }
> = ({
  campaignType,
  setCampaignType,
  currentValues,
  updateBodyField,
  showAdvancedSettings,
  setShowAdvancedSettings,
  presetData,
}) => {
  const serviceCampaignType =
    campaignType !== "BOOSTING" ? campaignType : undefined;
  const isVpdCampaign = useMemo(() => campaignType === "VPD", [campaignType]);

  return (
    <SubSectionWithStyles title="General Information" isSubHeader={false}>
      <FormRow labelText="Campaign Name" labelHtmlFor="name">
        <input
          type="text"
          name="name"
          id="name"
          required
          className={INPUT_FIELD_STYLES}
        />
      </FormRow>

      <CampaignTypeRadio
        campaignType={campaignType}
        setCampaignType={setCampaignType}
      />

      {serviceCampaignType && (
        <CampaignPreset
          {...presetData}
          campaignType={serviceCampaignType}
          setShowAdvancedSettings={setShowAdvancedSettings}
        />
      )}

      {presetData.campaignPreset === "copy" &&
        serviceCampaignType &&
        !isVpdCampaign && (
          <InfoRow infoText="Assigned categories can't be configured here. Please set them after creation." />
        )}

      {currentValues &&
        serviceCampaignType &&
        RenderSwitchableSettings("active", { currentValues, updateBodyField })}

      {currentValues &&
        showAdvancedSettings &&
        serviceCampaignType &&
        !isVpdCampaign && (
          <>
            {generalInformationSwitchableSettings
              .filter((key) => key !== "active")
              .map((setting) =>
                RenderSwitchableSettings(setting, {
                  currentValues,
                  updateBodyField,
                }),
              )}
            {generalInformationNumericSettings.map((key) => (
              <NamedNumberic
                key={key}
                title={controlledInputTitles[key]}
                value={currentValues[key]}
                onChange={(target) =>
                  updateBodyField({ [key]: parseNumberOrZero(target.value) })
                }
              />
            ))}
            <NamedSelect
              title={selectSettingsTitles.preferredImage}
              options={preferredImageSettings}
              customId="preferredImage"
              styleVariant="newPage"
            />
          </>
        )}
    </SubSectionWithStyles>
  );
};
